import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "../page/page.css";
import Header from "../components/header";
import TopImage from "../components/top";
import Description from "../components/description";
import Line from "../components/line";
import Cart from "../components/cart";
import Content from "../components/text-content";
import BottomDescription from "../components/bottom-desc";
import BottomContent from "../components/bottom";
import ContactForm from "../components/input-mail";

function MainPage() {
  return (
    <>
      <div className="page-align">
        <Header />
        <TopImage />
      </div>
      <Description />
      <Line />
      <Cart />
      <Content />
      <BottomDescription />
      <ContactForm />
      <BottomContent />
    </>
  );
}

export default MainPage;
